import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import type { RelativePerformancePanelConfig } from '@src/types/LayoutConfig';
import { useCallback } from 'react';
import { Panel } from '../../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../../types';
import { ComparisonModule } from './ComparisonModule';

export function ComparisonPanel({ api, params }: LayoutPanelProps<RelativePerformancePanelConfig>) {
  const { enableSignals } = useFeatureFlag();

  const handleParamsChange = useCallback(
    (partial: Partial<RelativePerformancePanelConfig>) => api.updateParameters(partial),
    [api]
  );

  if (!enableSignals) {
    return null;
  }

  return (
    <Panel
      panelApi={api}
      position="relative"
      display="flex"
      flexDirection="column"
      overflow="hidden"
      data-testid="relative-performance-panel"
    >
      <ComparisonModule params={params} onParamsChange={handleParamsChange} />
    </Panel>
  );
}
